<template>
  <div class="columns is-multiline">
    <div class="column is-12">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('ecranNumerique.onglet.produit')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-marginless is-paddingless is-multiline">
            <figure class="column is-2">
              <app-logo readOnly class="is-pulled-left"
               :elementId="produit.id"
               :libelleElement="$t('ecranNumerique.libelleProduitForLogo',
                  { ref: produit.reference })">></app-logo>
            </figure>
            <div class="column is-6">
              <div class="columns">
                <div class="column is-12">
                  <p class="has-text-default is-italic is-size-7">
                    {{ $t('catalogue.number', { reference: produit.reference })}}
                  </p>
                  <p class="is-size-4 has-text-weight-semibold">{{produit.libelle}}</p>
                  <p class="has-text-default is-italic is-size-7">
                    {{ produit.tiers ? produit.tiers.nomCommercial : null }}
                  </p>
                </div>
              </div>
              <b-field>
                <div class="column is-4 is-multiline is-paddingless">
                  <p class="has-text-default is-italic">
                    {{ $t('ecranNumerique.codePanneau')}}
                  </p>
                  <p class="has-text-weight-semibold">
                    {{produit.produitEcranNumerique.codePanneau}}
                  </p>
                  <div class="mgt-20px">
                    <p class="has-text-default is-italic">
                      {{ $t('ecranNumerique.materiel')}}
                    </p>
                    <p class="has-text-weight-semibold">
                      {{ produit.produitEcranNumerique.materielType}}
                    </p>
                  </div>
                  <div class="mgt-20px">
                    <p class="has-text-default is-italic">
                      {{ $t('ecranNumerique.support')}}
                    </p>
                    <p class="has-text-weight-semibold">
                      {{ produit.produitEcranNumerique.support}}
                    </p>
                  </div>
                  <div class="mgt-20px">
                    <p class="has-text-default is-italic">
                      {{ $t('ecranNumerique.dureeSpot')}}
                    </p>
                    <p class="has-text-weight-semibold">
                      {{ produit.produitEcranNumerique.dureeSpot }}
                    </p>
                  </div>
                  <div class="mgt-20px">
                    <p class="has-text-default is-italic">
                      {{ $t('ecranNumerique.dureeBoucle')}}
                    </p>
                    <p class="has-text-weight-semibold">
                      {{ produit.produitEcranNumerique.dureeBoucle}}
                    </p>
                  </div>
                  <div class="mgt-20px">
                    <p class="has-text-default is-italic">
                      {{ $t('ecranNumerique.localisation')}}
                    </p>
                    <p class="has-text-weight-semibold">
                      {{ produit.produitEcranNumerique.localisation }}
                    </p>
                  </div>
                  <div class="mgt-20px" v-if="ligneCommandeARenouvelerSpe">
                    <p class="has-text-default is-italic">
                      {{ $t('ecranNumerique.renouvelable')}}
                    </p>
                    <p class="has-text-weight-semibold">
                      {{ produit.renouvelable ? $t('general.oui') : $t('general.non') }}
                    </p>
                  </div>
                </div>
                <div class="column is-4 is-multiline is-paddingless">
                  <p class="has-text-default is-italic">
                    {{ $t('detailProduitReseauNumerique.agence') }}
                  </p>
                  <p class="has-text-weight-bold is-narrow">
                    {{ getAgenceLibelle }}
                  </p>
                  <div class="mgt-20px">
                    <p class="has-text-default is-italic">
                      {{ $t('ecranNumerique.format')}}
                    </p>
                    <p class="has-text-weight-semibold">
                      {{ produit.produitEcranNumerique.format }}
                    </p>
                  </div>
                  <div class="mgt-20px">
                    <p class="has-text-default is-italic">
                      {{ $t('ecranNumerique.tarif')}}
                    </p>
                    <p class="has-text-weight-semibold">
                      {{ getTarif }}
                    </p>
                  </div>
                  <div class="mgt-20px">
                    <p class="has-text-default is-italic">
                      {{ $t('ecranNumerique.angleVision')}}
                    </p>
                    <p class="has-text-weight-semibold">
                      {{produit.produitEcranNumerique.angleDeVision}}
                    </p>
                  </div>
                  <div class="mgt-20px">
                    <p class="has-text-default is-italic">
                      {{ $t('ecranNumerique.enVenantDe')}}
                    </p>
                    <p class="has-text-weight-semibold">
                      {{produit.produitEcranNumerique.enVenantDe}}
                    </p>
                  </div>
                  <div class="mgt-20px">
                    <p class="has-text-default is-italic">
                      {{ $t('ecranNumerique.enAllantVers')}}
                    </p>
                    <p class="has-text-weight-semibold">
                      {{produit.produitEcranNumerique.enAllantVers}}
                    </p>
                  </div>
                </div>
                <div class="column is-4 is-multiline is-paddingless">
                  <div  v-if="societesInformations.length > 1">
                    <p class="has-text-default is-italic">
                      {{ $t('ecranNumerique.societe') }}
                    </p>
                    <p class="has-text-weight-bold is-narrow">
                      {{ getLibelleSociete }}
                    </p>
                  </div>
                  <div class="mgt-20px">
                    <p class="has-text-default is-italic">
                      {{ $t('ecranNumerique.adresseCommercial')}}
                    </p>
                    <p class="has-text-weight-semibold">
                      {{
                        importedFunction.adressFullStringGetter(
                          produit.produitEcranNumerique.adresse)
                      }}
                      <b-tooltip
                        :label="$t('catalogue.newProduct.adressePersonalisee')"
                        multiline
                        type="is-warning"
                        v-if="produit.produitEcranNumerique.adressePersonalisee"
                        position="is-right"
                      >
                        <b-icon icon="alert" size="is-small" type="is-warning"
                          v-if="produit.produitEcranNumerique.adressePersonalisee"
                          ></b-icon>
                      </b-tooltip>
                    </p>
                  </div>
                  <div class="mgt-20px">
                    <p class="has-text-default is-italic">
                      {{ $t('ecranNumerique.departement')}}
                    </p>
                    <p class="has-text-weight-semibold">
                      {{ produit.produitEcranNumerique.adresse.departement}}
                    </p>
                  </div>
                  <div class="mgt-20px">
                    <p class="has-text-default is-italic">
                      {{ $t('ecranNumerique.aglomeration')}}
                    </p>
                    <p class="has-text-weight-semibold">
                      {{ produit.produitEcranNumerique.adresse.agglomeration }}
                    </p>
                  </div>
                  <div class="mgt-20px">
                    <p class="has-text-default is-italic">
                      {{ $t('ecranNumerique.outdoor')}}
                    </p>
                    <p class="has-text-weight-semibold">
                      {{ produit.produitEcranNumerique.outdoor ? $t('ecranNumerique.oui')
                      : $t('ecranNumerique.non')}}
                    </p>
                  </div>
                  <div class="mgt-20px">
                    <p class="has-text-default is-italic">
                      {{ $t('ecranNumerique.azimut')}}
                    </p>
                    <p class="has-text-weight-semibold">
                      {{produit.produitEcranNumerique.azimut}}
                    </p>
                  </div>
                </div>
              </b-field>
            </div>
            <gmap-map class="column is-4"
                      :center="center"
                      :zoom="zoomDefault">
              <gmap-marker :key="m.num"
                           v-for="(m) in markers"
                           :position="m.position"
                           :draggable="false"
                           :icon="m.icon">
              </gmap-marker>
            </gmap-map>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-6">
      <div class="card height-100">
        <header class="header-card">
          <p>
            {{ $t('catalogue.newProduct.restrictionAffichage.title') }}
          </p>
        </header>
        <div class="card-content">
          <restriction :produit="produit.produitEcranNumerique" :visualisation="true"/>
        </div>
      </div>
    </div>
    <compte-analytique :produit="produit" column-size="is-6"></compte-analytique>
    <produit-commentaire-vente-card
      :produit="produit"
      class="column is-6"
      isDetail/>
    <div class="column is-12">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('piecesJointes.attachments')}}
          </p>
        </header>
        <div class="card-content">
          <app-pieces-jointes :checkPermissions="checkPermissions(permsCatalogue.maj)"
                              readOnly deletable autoSave :canAddPj="!produitWithHolding"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import PiecesJointes from '@/components/general/piecesJointes';
import Logo from '@/components/general/Logo';
import markersGetter from '@/services/general/map/markersGetter';
import centerMapGetter from '@/services/catalogue/produitReseau/centerMapGetter';
import { ZOOM_DEFAULT, COULEUR_PUCE_DEFAULT } from '@/configuration/general/carteConf';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import getLiaisonTarifADate from '@/services/catalogue/getLiaisonTarifADate';
import { formatDevise } from '@/services/general/filters/formatDevise';
import restriction from '@/components/catalogue/restriction';
import compteAnalytique from '@/components/catalogue/produitGeneral/compteAnalytique/c_compteAnalytiqueCard';
import produitCommentaireVenteCard from '@/components/catalogue/produitGeneral/produitCommentaireVenteCard';
import { siteHasHolding } from '@/services/general/holding';
import MixinParametreInterne from '@/mixins/parametreInterne';

const Parametres = createNamespacedHelpers('parametres');
const permissions = createNamespacedHelpers('permissions');
const User = createNamespacedHelpers('user');
const Societe = createNamespacedHelpers('societe');

export default {
  mixins: [MixinParametreInterne],
  name: 'c_ecranNumerique',
  props: {
    produit: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      zoomDefault: ZOOM_DEFAULT,
      permsCatalogue: CATALOGUE,
      importedFunction: {
        adressFullStringGetter,
      },
    };
  },
  components: {
    appPiecesJointes: PiecesJointes,
    appLogo: Logo,
    restriction,
    compteAnalytique,
    produitCommentaireVenteCard,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societesInformations: 'societesInformations',
    }),
    produitWithHolding() {
      return (siteHasHolding() && this.produit
        && this.produit.supportCommercial.societeId !== this.societeActiveId);
    },
    getAgenceLibelle() {
      const agenceFind = this.user.agences.find((agence) => {
        return agence.agenceId === this.produit.agenceId;
      });
      if (agenceFind) return agenceFind.libelleAgence;
      return '';
    },
    getLibelleSociete() {
      const societe = this.societesInformations.find((societe) => {
        return societe.id === this.produit.supportCommercial.societeId;
      });
      if (societe) return societe.libelle;
      return '';
    },
    getTarif() {
      if (this.produit.liaisonsTarif && this.produit.produitEcranNumerique.produitParDefautId) {
        const produitLocation = getLiaisonTarifADate(
          this.produit,
          this.produit.produitEcranNumerique.produitParDefautId,
          new Date(),
        );
        if (produitLocation) return formatDevise(produitLocation.prixUnitaire);
      }
      return this.$t('ecranNumerique.nonDefini');
    },
    markers() {
      return markersGetter(this.produit.produitEcranNumerique.adresse, COULEUR_PUCE_DEFAULT,
        this.produit.produitEcranNumerique.azimut);
    },
    center() {
      return centerMapGetter(this.produit.produitEcranNumerique, this.markers);
    },
  },
};
</script>
